export const baseUrl = '/rest';
export const authUrl = `${baseUrl}/auth`;
